// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\BillingPaymentMethodCardResponse

export type BillingPaymentMethodCardApiResponse = {
	last4: string;
	expMonth: number;
	expYear: number;
	displayBrand: string | null;
};

export type BillingPaymentMethodCard = {
	last4: string;
	expMonth: number;
	expYear: number;
	displayBrand: string | null;
};

export function hydrateBillingPaymentMethodCard(data: BillingPaymentMethodCardApiResponse): BillingPaymentMethodCard {
	return { ...data };
}